import { EmptyContent } from "@imminently/react/ui/core/empty-content";
import { Text } from "@imminently/react/ui/core/text";
import React from "react";
import { useParams, useRouteError, useSearchParams } from "react-router-dom";

export const Error = () => {
  const params = useParams();
  const [search] = useSearchParams();

  return (
    <div>
      <h2>Error</h2>
      <p>Oops something went wrong.</p>
      {params && JSON.stringify(params, null, 2)}
      <pre>
        <code>
          {Array.from(search.entries()).map(
            ([k, v]) =>
              // <p>
              `${k}: ${v}\n`
            // </p>
          )}
        </code>
      </pre>
    </div>
  );
};

export const FallbackError = () => {
  const error = useRouteError() as Error;

  const message = (error && error.message) ?? "Unknown error";

  return (
    <EmptyContent sx={{ backgroundColor: "white", color: "#000" }}>
      <Text variant="h2">Error</Text>
      <Text>Oops something went wrong.</Text>
      <Text>{message}</Text>
    </EmptyContent>
  );
};